import React, { useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/ErrorMessage'
import EmployeeDetail from './EmployeeDetail'

const SalaryAdd = ({ handleCategory, allSubscription }) => {
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {}
  })

  const [employeeList, setEmployeeList] = useState('')
  const [employee, setEmployee] = useState('')
  const [item, setItem] = useState({})
  const [step, setStep] = useState(1)

  const onSubmit = () => {
    try {
      setStep(2)
    } catch (err) {
      console.log('err:', err)
    }
  }

  const getOnboardEmployeeList = async () => {
    try {
      const payload = {
        formStatus: 'accepted'
      }
      const res = await apiGet(apiPath.finalAccountantEmployeeList, payload)
      setEmployeeList(res?.data?.results)
    } catch (error) {
      console.log('error:', error)
    }
  }

  useEffect(() => {
    getOnboardEmployeeList()
  }, [])

  const selectEmployee = e => {
    if (e.target.value) {
      setEmployee(e.target.value)
      const filteredData = employeeList?.docs?.filter(
        itemEmployee => itemEmployee?._id === e.target.value
      )
      setItem(filteredData[0])
      clearErrors('employeeID')
    } else {
      setEmployee('')
      setItem({})
      setError('employeeID', {
        type: 'validation',
        message: 'Please select employee.'
      })
    }
  }

  return (
    <>
      <div className='justify-center items-center flex  overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-5xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7 mt-28'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('CREATE_SALARY')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => handleCategory(false)}
                  title='Close'
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              {step === 1 ? (
                <form onSubmit={handleSubmit(onSubmit)} method='post'>
                  <div className='relative p-6 flex-auto'>
                    <div className='grid sm:grid-cols-2'>
                      <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
                        <div className='relative z-0 w-full group'>
                          <select
                            type='select'
                            id='employeeID'
                            className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                            placeholder=' '
                            value={employee}
                            {...register('employeeID', {
                              required: 'Please select employee.'
                            })}
                            onChange={selectEmployee}
                          >
                            <option value=''>
                              {t('SELECT_EMPLOYEE_LIST')}
                            </option>
                            {employeeList?.docs?.length > 0 &&
                              employeeList?.docs?.map(itemList => {
                                return (
                                  <option
                                    key={itemList?.Employee?.employeeID}
                                    value={itemList?._id}
                                  >
                                    {itemList?.Employee?.name}
                                  </option>
                                )
                              })}
                          </select>
                          <label
                            htmlFor='employeeID'
                            className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                          >
                            {' '}
                            {t('SELECT_EMPLOYEE')}
                            <span className='text-red-500'>*</span>
                          </label>
                          <ErrorMessage message={errors?.employeeID?.message} />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*footer*/}
                  <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                    <button
                      className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                      type='submit'
                    >
                      {t('O_OK')}
                    </button>
                  </div>
                </form>
              ) : (
                <EmployeeDetail
                  employeeItem={item}
                  handleCategory={handleCategory}
                  allSubscription={allSubscription}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default SalaryAdd
